import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
let { WizContainer, modelUtils } = framework_tool;
import { ExportExcel } from '@/components/index'
let { WizSpin,WizTypography, WizModal } = component_tool;
const { Paragraph } = WizTypography;
let { Session } = utils_tool

let getLabelId = (history) => {
  let labelId = 0;
  if (history.location && history.location.record) {
    let record = history.location.record
    labelId = record?.labelId || 0
    Session.set('labelId', labelId)
  } else {
    labelId = Session.get('labelId') || 0
  }
  return labelId
}
class LabelUserImport extends WizContainer {

  componentName = 'LabelUserImport';

  constructor(props) {
    super(props);
    const {history} = props
    let labelId = getLabelId(history)
    this.state = {
      labelId: labelId || 0
    }
  }


  _handldImport(nextProps, nextState) {
    let o = nextProps['labelUserImports']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({
        title:'导入结果',
        content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  propsAndStateOnChange = {
    labelUserImports: this._handldImport.bind(this),
  }


  _render() {
    let {labelId} =this.state;
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '标签人员导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_labelUserTemp,
      }

    }
    let submit = (file, fileData) => {
      let apiPath = 'labelUser/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
            "labelId":labelId
          }
        }
      });
    }
    let { labelUserLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={labelUserLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { labelUser } = state;
  const labelUserImports = modelUtils.getModelEntity(labelUser, 'import');
  const load = modelUtils.getLoadingState(state, 'labelUser')
  return {
    labelUserImports: labelUserImports,
    ...load
  }
};

export default connect(mapStateToProps)(LabelUserImport);
